<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div id="viewProforma" #viewProforma> <!--Add class="bg-white" in kbmresorts-->
  <div class="vh-720 d-flex justify-content-center align-items-center">
    <div class="viewProforma-details">
      <div class="row">
        <div class="col-12 d-flex flex-column justify-content-center align-items-center pb-4">
          <!-- Change path to assets/images/logo 2.png in kbmresorts -->
          <img src="assets/img/logo 2.png" style="width: auto; height: 100px;" />
        </div>
        <div class="col-12 d-flex flex-column justify-content-center align-items-center pb-2">
          <h2 class="mb-1">Rental Income Analysis</h2>
          @if (isAdmin) {
            <h5 data-html2canvas-ignore="true" style="white-space: pre; color:red;">{{dateOverLappingMsg}}
            </h5>
            @if (proformaObj?.confId) {
              <div data-html2canvas-ignore="true" style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;justify-content:center;">
                <button pButton pRipple
                  [class]="copyLinkCopied ? 'p-button p-button-success' : 'p-button p-button-outlined'"
                  style="padding: 0.643rem 0.75rem !important;"
                  (click)="copyLink()">
                  <i [class]="copyLinkCopied ? 'pi pi-check' : 'pi pi-link'" style="margin-right: 6px;"></i>
                  {{copyLinkLabel}}
                </button>
                <button pButton pRipple class="p-button"
                  style="padding: 0.643rem 0.75rem !important;"
                  (click)="openSendToProspect()">
                  <i class="pi pi-send" style="margin-right: 6px;"></i>
                  Send to Prospect
                </button>
              </div>
              @if (viewStatsLoading) {
                <small data-html2canvas-ignore="true" style="margin-top: 6px; color: #888;">
                  <i class="pi pi-spin pi-spinner" style="font-size: 0.75rem;"></i> Loading views...
                </small>
              }
              @if (!viewStatsLoading && viewStats && viewStats.viewCount > 0) {
                <small data-html2canvas-ignore="true" style="margin-top: 6px; color: #555;">
                  Viewed {{viewStats.viewCount}} time{{viewStats.viewCount === 1 ? '' : 's'}}
                  @if (viewStats.lastViewedAt) {
                    &nbsp;&middot;&nbsp;Last opened {{formatLastViewed(viewStats.lastViewedAt)}}
                  }
                </small>
              }
              @if (!viewStatsLoading && viewStats && viewStats.viewCount === 0) {
                <small data-html2canvas-ignore="true" style="margin-top: 6px; color: #888;">Not yet viewed</small>
              }
            }
          }
        </div>
      </div>
      <div class="row">
        @if (propertyLeadProfile) {
          <div class="col-lg-3 d-flex flex-column justify-content-start align-items-center pb-3">
            <p style="font-weight: 500;">Destination:</p>
            <p class="mt-1 mb-0 text-center">{{propertyLeadProfile?.subjAdrDevelopmentName}}</p>
            <p class="mt-1 mb-0 text-center">{{propertyLeadProfile?.subjAdrStreet}}@if (propertyLeadProfile?.subjAdrUnit) {
              <span
              >,</span>
            } {{propertyLeadProfile?.subjAdrUnit}}</p>
            <p class="mt-1 mb-0 text-center">{{propertyLeadProfile?.subjAdrCity}}@if (propertyLeadProfile?.subjAdrState) {
              <span
              >,</span>
              } {{propertyLeadProfile?.subjAdrState}}@if (propertyLeadProfile?.subjAdrPostalCode) {
              <span
              >,</span>
            } {{propertyLeadProfile?.subjAdrPostalCode}}</p>
          </div>
        }
        @if (ownerLeadProfile) {
          <div class="col-lg-3 d-flex flex-column justify-content-start align-items-center pb-3">
            <p style="font-weight: 500;">Prepared for:</p>
            <p class="mt-1 mb-0 text-center">{{ownerLeadProfile?.firstName}} {{ownerLeadProfile?.lastName}}</p>
            <p class="mt-1 mb-0 text-center">{{ownerLeadProfile?.emailAddress}}</p>
            <p class="mt-1 mb-0 text-center">{{ownerLeadProfile?.mobilePhone}}</p>
            <p class="mt-1 mb-0 text-center">{{ownerLeadProfile?.mailAdrStreet}} {{ownerLeadProfile?.mailAdrStreet2}}</p>
            <p class="mt-1 mb-0 text-center">{{ownerLeadProfile?.mailAdrCity}} @if (ownerLeadProfile?.mailAdrState) {
              <span>,</span>
            }
          {{ownerLeadProfile?.mailAdrState}} {{ownerLeadProfile?.mailAdrPostalCode}}</p>
        </div>
      }
      @if (realtorProfile) {
        <div class="col-lg-3 d-flex flex-column justify-content-start align-items-center">
          <p style="font-weight: 500;">Realtor:</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.firstName}} {{realtorProfile?.lastName}}</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.adrCompanyName}}</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.emailAddress}}</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.mobilePhone}}</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.adrStreet}} {{realtorProfile?.adrStreet2}}</p>
          <p class="mt-1 mb-0 text-center">{{realtorProfile?.adrCity}}@if (realtorProfile?.adrState) {
            <span>,</span>
          }
        {{realtorProfile?.adrState}} {{realtorProfile?.adrPostalCode}}</p>
      </div>
    }
    @if (createdBy) {
      <div class="col-lg-3 d-flex flex-column justify-content-start align-items-center">
        <p style="font-weight: 500;">Prepared By:</p>
        <p class="mt-1 mb-0 text-center">{{createdBy?.firstName}} {{createdBy?.lastName}}</p>
        <p class="mt-1 mb-0 text-center">{{createdBy?.title}}</p>
        <p class="mt-1 mb-0 text-center">{{createdBy?.emailAddress}}</p>
        <p class="mt-1 mb-0 text-center">{{createdBy?.mobilePhone}}</p>
        <p class="mt-1 mb-0 text-center">www.kbmresorts.com</p>
      </div>
    }
  </div>
  <div class="row d-none">
    <div class="col-2 d-flex flex-column">
      <p style="font-weight: 500;">Luxury Property Management</p>
    </div>
    @if (ownerLeadProfile) {
      <div class="col d-flex flex-column w-100">
        <p style="font-weight: 500;">Prepared for:</p>
        <p class="mt-1 mb-0">{{ownerLeadProfile?.firstName}} {{ownerLeadProfile?.lastName}}</p>
        <p class="mt-1 mb-0">{{ownerLeadProfile?.emailAddress}}</p>
        <p class="mt-1 mb-0">{{ownerLeadProfile?.mobilePhone}}</p>
        <p class="mt-1 mb-0">{{ownerLeadProfile?.mailAdrStreet}} {{ownerLeadProfile?.mailAdrStreet2}}</p>
        <p class="mt-1 mb-0">{{ownerLeadProfile?.mailAdrCity}} @if (ownerLeadProfile?.mailAdrState) {
          <span>,</span>
        }
      {{ownerLeadProfile?.mailAdrState}} {{ownerLeadProfile?.mailAdrPostalCode}}</p>
    </div>
  }
  @if (propertyLeadProfile) {
    <div class="col d-flex flex-column w-100">
      <p style="font-weight: 500;">Destination:</p>
      <p class="mt-1 mb-0">{{propertyLeadProfile?.subjAdrDevelopmentName}}</p>
      <p class="mt-1 mb-0">{{propertyLeadProfile?.subjAdrStreet}}@if (propertyLeadProfile?.subjAdrUnit) {
        <span
        >,</span>
      } {{propertyLeadProfile?.subjAdrUnit}}</p>
      <p class="mt-1 mb-0">{{propertyLeadProfile?.subjAdrCity}}@if (propertyLeadProfile?.subjAdrState) {
        <span
        >,</span>
        } {{propertyLeadProfile?.subjAdrState}}@if (propertyLeadProfile?.subjAdrPostalCode) {
        <span
        >,</span>
      } {{propertyLeadProfile?.subjAdrPostalCode}}</p>
    </div>
  }
  @if (createdBy) {
    <div class="col d-flex flex-column w-100">
      <p style="font-weight: 500;">Prepared By:</p>
      <p class="mt-1 mb-0">{{createdBy?.firstName}} {{createdBy?.lastName}}</p>
      <p class="mt-1 mb-0">{{createdBy?.title}}</p>
      <p class="mt-1 mb-0">{{createdBy?.emailAddress}}</p>
      <p class="mt-1 mb-0">{{createdBy?.mobilePhone}}</p>
      <p class="mt-1 mb-0">www.kbmresorts.com</p>
    </div>
  }
  @if (realtorProfile) {
    <div class="col d-flex flex-column w-100">
      <p style="font-weight: 500;">Realtor Profile:</p>
      <p class="mt-1 mb-0">{{realtorProfile?.firstName}} {{realtorProfile?.lastName}}</p>
      <p class="mt-1 mb-0">{{realtorProfile?.adrCompanyName}}</p>
      <p class="mt-1 mb-0">{{realtorProfile?.emailAddress}}</p>
      <p class="mt-1 mb-0">{{realtorProfile?.mobilePhone}}</p>
      <p class="mt-1 mb-0">{{realtorProfile?.adrStreet}} {{realtorProfile?.adrStreet2}}</p>
      <p class="mt-1 mb-0">{{realtorProfile?.adrCity}}@if (realtorProfile?.adrState) {
        <span>,</span>
      }
    {{realtorProfile?.adrState}} {{realtorProfile?.adrPostalCode}}</p>
  </div>
}
</div>
</div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center pb-3">
        <h3 class="mb-1">Summary</h3>
      </div>
      <div class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center pb-0">
        <div class="table-responsive w-100">
          <table class="table datatable-table text-center riatable w-100">
            <thead>
              <tr>
                <th><i></i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><i>Expanding</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Stable'}"><i>Target</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><i>Contracting</i></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Gross Rents</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><b>{{proformaObj?.expansion?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}"><b>{{proformaObj?.stable?.grossNightlyRevAmnt | currency : 'USD' :
                'symbol' : '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><b>{{proformaObj?.contraction?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</b></td>
              </tr>
              <tr>
                <td>Nightly Rate</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{(proformaObj?.expansion?.grossNightlyRevAmnt / expansionAvgOccpNtgsTtl) | currency : 'USD' : 'symbol' :
                '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{(proformaObj?.stable?.grossNightlyRevAmnt / stableAvgOccpNtgsTtl) |
                currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{(proformaObj?.contraction?.grossNightlyRevAmnt / contractionAvgOccpNtgsTtl) | currency : 'USD' : 'symbol' :
                '1.0-0'}}</td>
              </tr>
              <tr>
                <td>Occupancy</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{expansionOccupancy}}%</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{stableOccupancy}}%</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{contractionOccupancy}}%</td>
              </tr>
              <tr>
                <td>Nights Rented</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{expansionAvgOccpNtgsTtl | number: '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{stableAvgOccpNtgsTtl | number: '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{contractionAvgOccpNtgsTtl | number: '1.0-0'}}</td>
              </tr>
              <tr>
                <td>Net Rental Income</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proformaObj?.expansion?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proformaObj?.stable?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}
                </td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proformaObj?.contraction?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4 mt-auto mb-0">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center mb-2">
        <h3 class="mb-1">Gross Revenue</h3>
      </div>
      <div
        class="col-10 mx-auto d-flex flex-column justify-content-center align-items-start mb-4 p-2 border border-start-0 border-end-0 border-bottom-0">
        <p>KBM Resorts calculates your gross rental income for {{proformaObj?.name}} at {{proformaObj?.expansion?.grossNightlyRevAmnt |
          currency : 'USD' : 'symbol' : '1.0-0'}} in an
          expanding market, {{proformaObj?.stable?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} as the target, and
        {{proformaObj?.contraction?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} in a contracting market. </p>

        <p class="mb-0">Click the buttons below to see the breakdown by month for each market</p>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 mb-4 ria-chart position-relative">
        <div class="ria-details-btn col d-flex flex-column align-items-center mt-0 mx-0">
          <p class="mb-2">Click to view:</p>
          <div class="riaselectbtn ms-3">
            <div class="flex justify-content-center">
              <p-selectButton [options]="proformaOptions" (onOptionClick)="onProformaOptionChange()"
              [(ngModel)]="currentProforma"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center mb-4 p-0">
        <div class="table-responsive w-100">
          <table class="table datatable-table text-center riatable w-100">
            <thead>
              <tr>
                <th><i></i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><i>Expanding</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Stable'}"><i>Target</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><i>Contracting</i></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Gross Rents</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><b>{{proformaObj?.expansion?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}"><b>{{proformaObj?.stable?.grossNightlyRevAmnt | currency : 'USD' :
                'symbol' : '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><b>{{proformaObj?.contraction?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 ria-chart position-relative">
        <div class="card col-12 p-bar-chart">
          <p-chart type="bar" [data]="revGraphData" [options]="revGraphOptions" [plugins]="chartDataLabelPlugins"
          [responsive]="true"></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4 mt-auto mb-0">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center mb-2">
        <h3 class="mb-1">Occupancy</h3>
      </div>
      <div
        class="col-10 mx-auto d-flex flex-column justify-content-center align-items-start mb-4 p-2 border border-start-0 border-end-0 border-bottom-0">
        <p>KBM Resorts calculates the occupancy for {{proformaObj?.name}} at {{expansionOccupancy}}% in an expanding market,
        {{stableOccupancy}}% as the target, and {{contractionOccupancy}}% in a contracting market. </p>
        <p class="mb-0">Click the buttons below to see the breakdown by month for each market</p>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 mb-4 ria-chart position-relative">
        <div class="ria-details-btn col d-flex flex-column align-items-center mt-0 mx-0">
          <p class="mb-2">Click to view:</p>
          <div class="riaselectbtn ms-3">
            <div class="flex justify-content-center">
              <p-selectButton [options]="proformaOptions" (onOptionClick)="onProformaOptionChange()"
              [(ngModel)]="currentProforma"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center mb-4 p-0">
        <div class="table-responsive w-100">
          <table class="table datatable-table text-center riatable w-100">
            <thead>
              <tr>
                <th><i></i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><i>Expanding</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Stable'}"><i>Target</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><i>Contracting</i></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Occupied</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><b>{{expansionOccupancy}}%</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}"><b>{{stableOccupancy}}%</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><b>{{contractionOccupancy}}%</b></td>
              </tr>
              <tr>
                <td><b>Nights Rented</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><b>{{expansionAvgOccpNtgsTtl | number: '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}"><b>{{stableAvgOccpNtgsTtl | number: '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><b>{{contractionAvgOccpNtgsTtl | number: '1.0-0'}}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb-3">
          <div class="col-lg-4 p-occupancy-chart">

            <p-chart type="doughnut" id="expansionDoughnutOccup" [data]="expansionDoughnutData"
            [options]="expansionDoughnutOptions" [plugins]="chartDataLabelPlugins"></p-chart>

          </div>
          <div class="col-lg-4 p-occupancy-chart">
            <p-chart type="doughnut" id="stableDoughnutOccup" [data]="stableDoughnutData"
            [options]="stableDoughnutOptions" [plugins]="chartDataLabelPlugins"></p-chart>
          </div>
          <div class="col-lg-4 p-occupancy-chart">
            <p-chart type="doughnut" id="contractionDoughnutOccup" [data]="contractionDoughnutData"
            [options]="contractionDoughnutOptions" [plugins]="chartDataLabelPlugins"></p-chart>
          </div>
        </div>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 ria-chart position-relative">
        <div class="card col-12 p-bar-occupancy-chart">
          <p-chart type="bar" [data]="occupGraphData" [options]="occupGraphOptions" [plugins]="chartDataLabelPlugins"
          [responsive]="true"></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4 mt-auto mb-0">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center pb-2">
        <h3 class="mb-1">Nightly Rate</h3>
      </div>
      <div
        class="col-10 mx-auto d-flex flex-column justify-content-center align-items-start mb-3 p-2 border border-start-0 border-end-0 border-bottom-0">
        <p>KBM Resorts calculates the occupancy for {{proformaObj?.name}} at {{expansionOccupancy}}% in an expanding market,
        {{stableOccupancy}}% as the target, and {{contractionOccupancy}}% in a contracting market. </p>
        <p class="mb-0">Click the buttons below to see the breakdown by month for each market</p>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 mb-4 ria-chart position-relative">
        <div class="ria-details-btn col d-flex flex-column align-items-center mt-0 mx-0">
          <p class="mb-2">Click to view:</p>
          <div class="riaselectbtn ms-3">
            <div class="flex justify-content-center">
              <p-selectButton [options]="proformaOptions" (onOptionClick)="onProformaOptionChange()"
              [(ngModel)]="currentProforma"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center mb-4 p-0">
        <div class="table-responsive w-100">
          <table class="table datatable-table text-center riatable w-100">
            <thead>
              <tr>
                <th><i></i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><i>Expanding</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Stable'}"><i>Target</i></th>
                <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><i>Contracting</i></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Nightly Rate</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}"><b>{{(proformaObj?.expansion?.grossNightlyRevAmnt / expansionAvgOccpNtgsTtl) | currency : 'USD' : 'symbol' :
                '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}"><b>{{(proformaObj?.stable?.grossNightlyRevAmnt /
                stableAvgOccpNtgsTtl) | currency : 'USD' : 'symbol' : '1.0-0'}}</b></td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}"><b>{{(proformaObj?.contraction?.grossNightlyRevAmnt / contractionAvgOccpNtgsTtl) | currency : 'USD' :
                'symbol' : '1.0-0'}}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center p-0 ria-chart position-relative">
        <div class="card col-12 p-bar-chart">
          <p-chart type="line" [data]="avgNgtRateData" [options]="avgNgtRateOptions" [plugins]="chartDataLabelPlugins"
          [responsive]="true"></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4 mt-auto mb-0">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center pb-2">
        <h3 class="mb-1">Seasons</h3>
      </div>
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-start mb-3 p-2 ">
        <p class="mb-0">KBM Resorts performs an individual calculation of each night. For presentation, we have
        divided the year into ‘seasons’ for clarity.</p>
      </div>
      <div class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center pb-0">
        <div class="table-responsive w-100">
          <p-table [value]="proformaIncomes"
            class="table datatable-table text-start riatable w-100 net-rent-income-table" id="incometable">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-start bg-warning text-white" colspan="7"><strong>Net Rent Income</strong></th>
                <th class="text-end bg-warning text-white">
                  @if (isAdmin) {
                    <button class="btn btn-icon btn-success rounded-pill" data-html2canvas-ignore="true"
                      (click)="onOpenIncomeAdd()">
                      <i class="pi pi-plus"></i>
                    </button>
                  }
                </th>
              </tr>
              <tr>
                <th>Season<sup>1</sup></th>
                <th>Start</th>
                <th>End</th>
                <th>Days</th>
                <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}">Market Expansion {{(proformaObj?.expansionNightAvg * 100) | number : '1.2-2'}}%</th>
                <th [ngClass]="{'orange-text': currentProforma == 'Stable'}">Market Stable {{(proformaObj?.stableNightAvg * 100) |
                number : '1.2-2'}}%</th>
                <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}">Market Contraction {{(proformaObj?.contractionNightAvg * 100) | number : '1.2-2'}}%</th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-proforma>
              <tr>
                <td>{{proforma.seasonName}}</td>
                <td>{{proforma.seasonStart | date}}</td>
                <td>{{proforma.seasonEnd | date}}</td>
                <td>{{proforma.numNights}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proforma.expansionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proforma.stableRate | currency : 'USD' : 'symbol' :
                '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proforma.contractionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td>
                  <a>
                    @if (isAdmin) {
                      <i class="pi pi-pencil" aria-hidden="true" data-html2canvas-ignore="true"
                        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenIncomeUpdate(proforma)">
                      </i>
                    }
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="vh-720 d-flex justify-content-center align-items-center">
  <div class="viewProforma-details w-100 px-4">
    <div class="row">
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-center pb-2">
        <h3 class="mb-1">Rental Expenses</h3>
      </div>
      <div class="col-10 mx-auto d-flex flex-column justify-content-center align-items-start mb-3 p-2 ">
        <p class="mb-0">KBM Resorts’ complete program, inclusive of all homeowner benefits, complementary
          maintenance, and other features, is provided for a single management expense of 25%. This
          expense is assessed solely on net nightly rate income, and is not charged to any other fee, tax, or
        expense. Other expenses</p>
      </div>
      <div class="col-12 mx-auto d-flex flex-column justify-content-center align-items-center pb-0">
        <div class="table-responsive w-100">
          <p-table [value]="proformaExpenseObj"
            class="table datatable-table text-start riatable w-100 net-rent-income-table">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-start bg-warning text-white" colspan="7"><strong>Rent Expense</strong></th>
                <th class="text-end bg-warning text-white">
                  @if (isAdmin) {
                    <button class="btn btn-icon btn-success rounded-pill" data-html2canvas-ignore="true"
                      (click)="onOpenExpenseAdd()">
                      <i class="pi pi-plus"></i>
                    </button>
                  }
                </th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Amount</th>
                <th>Qty</th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
                <th [ngStyle]="{'width': 'auto'}"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-proforma>
              <tr>
                <td>{{proforma.name}}</td>
                @if (proforma.expensePct != undefined) {
                  <td>{{proforma.expensePct | percent}}</td>
                }
                @if (proforma.expensePct == undefined && proforma.expenseAmnt != undefined) {
                  <td>
                    {{proforma.expenseAmnt |
                  currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                }
                <td>{{proforma.quantity}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proforma.expansionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proforma.stableRate | currency : 'USD' : 'symbol' :
                '1.0-0'}}</td>
                <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proforma.contractionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                <td>
                  <a>
                    @if (isAdmin) {
                      <i class="pi pi-pencil" aria-hidden="true" data-html2canvas-ignore="true"
                        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenExpenseUpdate(proforma)">
                      </i>
                    }
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
<br />

<div class="d-none">

  <!-- <div class="col-md-2 offset-md-10 mt-2">
  <div class="row">
    <div class="col-md-6 text-right">
      <button *ngIf="isAdmin" pButton pRipple class="p-button" data-html2canvas-ignore="true"
      style="padding: 0.643rem 0.75rem !important;" (click)="setTarget()">Target</button>
    </div>
    <div *ngIf="isAdmin" class="col-md-6 text-right">
      <button pButton pRipple class="p-button" data-html2canvas-ignore="true"
      style="padding: 0.643rem 0.75rem !important;" (click)="sendFullMail()">Share</button>
    </div>
  </div>
</div> -->
<div class="ria-details position-relative">
  <div class="ria-details-btn col d-flex align-items-center w-100 mt-4 mx-0">
    <div class="riaselectedbtn">
      <div class="flex justify-content-start">
        <p-selectButton [options]="proformaOptions" (onOptionClick)="onProformaOptionChange()"
        [(ngModel)]="currentProforma"></p-selectButton>
      </div>
    </div>
    <div class="riaselectbtn ms-3">
      <div class="flex justify-content-center">
        <p-selectButton [options]="proformaOptions" (onOptionClick)="onProformaOptionChange()"
        [(ngModel)]="currentProforma"></p-selectButton>
      </div>
    </div>
  </div>
  <div class="card">
    <p-chart type="bar" [data]="occupGraphData" [options]="occupGraphOptions" [plugins]="chartDataLabelPlugins"
    [responsive]="true"></p-chart>
  </div>
  <div class="col d-flex flex-column justify-content-end align-items-end w-100">

    <!-- <button pButton pRipple class="p-button" data-html2canvas-ignore="true" style="padding: 0.643rem 0.75rem !important;"
  (click)="downloadPDF()">Download</button> -->
</div>
<div class="row">
  <div class="col-3 text-center"><b>Total Projected Gross Revenue:</b></div>
  <div class="col-1 text-left">{{revanues | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
  <div class="col-8">(From {{proformaObj?.expansion?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} to
    {{proformaObj?.contraction?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} based on market conditions and
  pricing)</div>
</div>
<div class="row">
  <div class="col-3 text-center"><b>Total Projected NET proceeds:</b></div>
  <div class="col-1 text-left">{{proformaObj?.stable?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</div>
  <div class="col-8">(From {{proformaObj?.expansion?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} to
    {{proformaObj?.contraction?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}} based on market conditions,
    pricing,
  and net of 20% commission)</div>
</div>
<div class="row mt-3">
  <div class="col-4 text-center"><b>Total Projected Nights Rented</b></div>
  <div class="col-4 text-center"><b>Occupancy</b></div>
  <div class="col-4 text-center"><b>Average Nightly Rate</b></div>
</div>
<div class="row">
  <div class="col-4 text-center"><b>{{avgOccpNtgsTtl | number: '1.0-0'}}</b></div>
  <div class="col-4 text-center"><b>{{avgOccupancy}}%</b></div>
  <div class="col-4 text-center"><b>{{(revanues / avgOccpNtgsTtl) | currency : 'USD' : 'symbol' : '1.0-0'}}</b>
</div>
</div>
<div class="row card mt-4">
  <div class="col-12 text-center"><b>Total Projected Gross Revenue: {{revanues | currency : 'USD' : 'symbol' :
  '1.0-0'}}</b></div>
  <div class="col-12">
    <p-chart type="bar" [data]="revGraphData" [options]="revGraphOptions" [plugins]="chartDataLabelPlugins"
    [responsive]="true"></p-chart>
  </div>
</div>
<div class="row mt-4">
  <div class="col-3">
    <div class="card flex justify-content-center">
      <p-chart type="doughnut" id="doughnutOccup" [data]="doughnutData" [options]="doughnutOptions"
      [plugins]="chartDataLabelPlugins" [responsive]="true"></p-chart>
    </div>
    <!-- <h5 style="text-align: center;">occupancy {{avgOccupancy}}</h5> -->
  </div>
  <div class="col-9">
    <div class="card">
      <p-chart type="bar" [data]="occupGraphData" [options]="occupGraphOptions" [plugins]="chartDataLabelPlugins"
      [responsive]="true"></p-chart>
    </div>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 text-center"><b>Average Nightly Rate: {{(revanues / avgOccpNtgsTtl) | currency : 'USD' :
    'symbol'
  : '1.0-0'}}</b></div>
  <div class="card">
    <p-chart type="line" [data]="avgNgtRateData" [options]="avgNgtRateOptions" [plugins]="chartDataLabelPlugins"
    [responsive]="true"></p-chart>
  </div>
</div>
</div>
<div class="mb-4 mt-8 datatable rent Rent-Income px-4">
  <div class="table-responsive">
    <p-table [value]="proformaIncomes" class="table datatable-table" id="incometable">

      <!-- Rent Income Table -->

      <ng-template pTemplate="header">
        <tr>
          <th class="text-start bg-warning text-white" colspan="7"><strong>Rent Income</strong></th>
          <th class="text-end bg-warning text-white">
            @if (isAdmin) {
              <button class="btn btn-icon btn-success rounded-pill" data-html2canvas-ignore="true"
                (click)="onOpenIncomeAdd()">
                <i class="pi pi-plus"></i>
              </button>
            }
          </th>
        </tr>
        <tr class="text-center">
          <th>Season<sup>1</sup></th>
          <th>Start</th>
          <th>End</th>
          <th>Days</th>
          <th [ngClass]="{'orange-text': currentProforma == 'Expansion'}">Market Expansion <br> {{(proformaObj?.expansionNightAvg * 100) | number : '1.2-2'}}%</th>
          <th [ngClass]="{'orange-text': currentProforma == 'Stable'}">Market Stable <br> {{(proformaObj?.stableNightAvg * 100) |
            number :
          '1.2-2'}}%</th>
          <th [ngClass]="{'orange-text': currentProforma == 'Contraction'}">Market Contraction <br> {{(proformaObj?.contractionNightAvg * 100) | number : '1.2-2'}}%</th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-proforma>
        <tr class="text-end">
          <td>{{proforma.seasonName}}</td>
          <td>{{proforma.seasonStart | date}}</td>
          <td>{{proforma.seasonEnd | date}}</td>
          <td>{{proforma.numNights}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proforma.expansionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proforma.stableRate | currency : 'USD' : 'symbol' :
          '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proforma.contractionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td>
            <a>
              @if (isAdmin) {
                <i class="pi pi-pencil" aria-hidden="true" data-html2canvas-ignore="true"
                  style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenIncomeUpdate(proforma)">
                </i>
              }
            </a>
          </td>
        </tr>


      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td></td>
          <td></td>
          <td>Rent Revenues</td>
          <td>{{proformaObj?.numNightsTtl}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proformaObj?.expansion?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proformaObj?.stable?.grossNightlyRevAmnt | currency : 'USD' :
            'symbol' : '1.0-0'}}
          </td>
          <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proformaObj?.contraction?.grossNightlyRevAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        </tr>
      </ng-template>
    </p-table>

  </div>

</div>

<!-- Rent Expense Table -->
<div class="mb-4 datatable rent Rent-Income px-4">
  <div class="table-responsive">

    <p-table [value]="proformaExpenseObj" class="table datatable-table">

      <ng-template pTemplate="header">

        <tr>
          <th class="text-start bg-warning text-white" colspan="8"><strong>Rent Expense</strong></th>
          <th class="text-end bg-warning text-white">
            @if (isAdmin) {
              <button class="btn btn-icon btn-success rounded-pill" data-html2canvas-ignore="true"
                (click)="onOpenExpenseAdd()">
                <i class="pi pi-plus"></i>
              </button>
            }
          </th>
        </tr>
        <tr class="text-center">
          <th>Name</th>
          <th>Amount</th>
          <th>Qty</th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-proforma>
        <tr>
          <td>{{proforma.name}}</td>
          @if (proforma.expensePct != undefined) {
            <td>{{proforma.expensePct | percent}}</td>
          }
          @if (proforma.expensePct == undefined && proforma.expenseAmnt != undefined) {
            <td>{{proforma.expenseAmnt
              |
            currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          }
          <td>{{proforma.quantity}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proforma.expansionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proforma.stableRate | currency : 'USD' : 'symbol' :
          '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proforma.contractionRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td></td>
          <td></td>
          <td>
            <a>
              @if (isAdmin) {
                <i class="pi pi-pencil" aria-hidden="true" data-html2canvas-ignore="true"
                  style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenExpenseUpdate(proforma)">
                </i>
              }
            </a>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td></td>
          <td>Rent Expenses</td>
          <td></td>
          <td [ngClass]="{'orange-text': currentProforma == 'Expansion'}">{{proformaObj?.expansionExpenses | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td [ngClass]="{'orange-text': currentProforma == 'Stable'}">{{proformaObj?.stableExpenses | currency : 'USD' :
            'symbol' : '1.0-0'}}
          </td>
          <td [ngClass]="{'orange-text': currentProforma == 'Contraction'}">{{proformaObj?.contractionExpenses | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<!-- Net Rent Income Table -->

<div class="mb-4 datatable rent Rent-Income px-4">
  <div class="table-responsive">
    <p-table [value]="proformaIncomes" class="table datatable-table">


      <ng-template pTemplate="header">
        <tr>
          <th class="text-start bg-warning text-white" colspan="8"><strong>Net Rent Income</strong></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td></td>
          <td></td>
          <td>Net Rental Income</td>
          <td></td>
          <td>{{proformaObj?.expansion?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td>{{proformaObj?.stable?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
          <td>{{proformaObj?.contraction?.netIncomeAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        </tr>

      </ng-template>

    </p-table>
  </div>
</div>

<div class="w-100 px-5">
  <div class="row align-items-center">
    <div class="col d-flex flex-column justify-content-center align-items-start">
      <h2 class="text-danger">KBM Hawaii Benefits</h2>
      <ul>
        <li>Ultra Low Management Expense</li>
        <li>Free Maintenance</li>
        <li>Free Rental Car during owner visits</li>
        <li>Free Housekeeping during owner visits</li>
        <li>Free monthly tax filing service</li>
      </ul>
    </div>
    <div class="col d-flex flex-column justify-content-center align-items-center w-100">
      <h2 class="mb-0">Rental income questions?</h2>
      <p class="mb-0">{{createdBy?.firstName}} {{createdBy?.lastName}}</p>
      <p class="mb-0">KBM Hawaii</p>
      <p class="mb-0">{{createdBy?.mobilePhone}}</p>
      <p class="mb-0">{{createdBy?.emailAddress}}</p>
      <p class="mt-1 mb-0">www.kbmresorts.com</p>
    </div>
  </div>
</div>

<div class="w-100 px-5">
  <div class="d-flex flex-column justify-content-center align-items-start">
    <h2 class="text-danger">Notes</h2>
    <ol class="">
      <li>Seasons are automatically defined by our proprietary pricing algorithm and will change frequently to
        maximize
        revenue opportunity vis-a-vi consumer demand. Revenue predictions assume conteporary furnishings and
        decor.
      </li>
      <li>Guest fees vary by reservation and include accomodation related amenities such as departure
        housekeeping,
        towel services, and guest services purchased by guest such as interim housekeeping, additional linens,
        roll-away
      beds, etc.</li>
      <li>KBM Hawaii collects, files, and remits your monthly General Excise and Transient Accomodation taxes on
        your
      behalf as a free service to you unless you elect to handle the monthly tax filing</li>
      <li>Management expense is only assessed on the nightly rate. Other revenues, such as taxes and resort fees
        are
      never subject to management expense.</li>
      <li>KBM Hawaii performs all routine, preventative, and guest service call maintenance at no additional cost
        and
        is
      included in the management expense.</li>
    </ol>
    <p>Future rental rates & occupancy are significantly impacted by external factors such as weather, global
      economic
      stability, airfare expense, oil futures, competitor 'dumping' of inventory, owner use, and others. KBM
      Hawaii
      updates the owners of the properites we manage frequently with economic market and rental rate trends. This
      proforma is an estimate of future earnings based on historical performance. Previous performance cannot
      guarantee
    future results.</p>
    <p>KBM Hawaii's proprietary yield management system automatically adjusts nightly room rates based on daily
      analysis
      of inquiry traffic by date, length of reservation, and proximity to ajoining reservations to maximize
      occupancy
      at
    the highest market price possible.</p>
    <p>KBM Hawaii's reservation software links together short spans of un-booked nights at similar villas to make
      one
      complete reservation. This proprietary feature reduces ‘gap days’ between traditional reservations with
      paying
    guests yielding increased revenue.</p>
    <p>KBM Hawaii's housekeeping system automatically schedules and manages same day guest check-out / check-in so
      you
    don’t lose potential revenue due to housekeeping downtime between reservations.</p>
  </div>
</div>
</div>
</div>

<!-- Send to Prospect Dialog -->
<p-dialog header="Send to Prospect" [(visible)]="sendToProspectVisible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{width:'480px'}" [closable]="true">
  <div style="display:flex;flex-direction:column;gap:12px;padding:4px 0;">
    <div>
      <label style="display:block;font-size:13px;font-weight:600;margin-bottom:4px;">To</label>
      <input pInputText [(ngModel)]="sendToProspectForm.toEmail" placeholder="recipient@email.com"
        style="width:100%;" type="email" />
    </div>
    <div>
      <label style="display:block;font-size:13px;font-weight:600;margin-bottom:4px;">Subject</label>
      <input pInputText [(ngModel)]="sendToProspectForm.subject" placeholder="Email subject"
        style="width:100%;" />
    </div>
    <div>
      <label style="display:block;font-size:13px;font-weight:600;margin-bottom:4px;">Personal Note <span style="font-weight:400;color:#888;">(optional)</span></label>
      <textarea pInputTextarea [(ngModel)]="sendToProspectForm.personalNote"
        placeholder="Add a personal message to appear at the top of the email..."
        [rows]="4" style="width:100%;resize:vertical;"></textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" class="p-button-text"
      (click)="sendToProspectVisible = false" [disabled]="sendToProspectLoading"></button>
    <button pButton pRipple label="Send" icon="pi pi-send" class="p-button"
      (click)="submitSendToProspect()" [loading]="sendToProspectLoading"></button>
  </ng-template>
</p-dialog>